import React from 'react'
import { Redirect, Route, Switch, Router } from 'react-router-dom'
import { ToastComponent } from '@provi/provi-components'
import { routesSanar } from './guarantor.routes'
import { routes } from './routes'
import { history } from './history'

export const Navigation = () => {
  return (
    <Router history={history}>
      <Switch>
        {routesSanar.map((item) => (
          <Route key={item.path} path={item.path} exact component={item.component} />
        ))}
        {routes.map((item) => (
          <Route key={item.path} path={item.path} exact component={item.component} />
        ))}
        <Redirect to="/" exact />
      </Switch>
      <ToastComponent />
    </Router>
  )
}
